import tlm_mob from '../images/photos/tlm_portrait.jpg'
import mixSpace from '../images/photos/mix-space_1600.jpg'
import inside_mob from '../images/photos/inside-bagnall-hill-studio_portrait.jpg'
import inside from '../images/photos/inside-bagnall-hill-studio_1600.jpg'
import pirongia_mob from '../images/photos/mount-pirongia_portrait.jpg'
import pirongia from '../images/photos/mount-pirongia_1600.jpg'
import preamps_mob from '../images/photos/preamps_portrait.jpg'
import preamps from '../images/photos/preamps_1600.jpg'

export const slides = [
  {
    src: mixSpace,
    srcMobile: tlm_mob,
    alt: 'Business end',
  },
  {
    src: inside,
    srcMobile: inside_mob,
    alt: 'Inside Bagnall Hill Recording Studio',
  },
  {
    src: preamps,
    srcMobile: preamps_mob,
    alt: 'Outboard Gear',
  },
  {
    src: pirongia,
    srcMobile: pirongia_mob,
    alt: 'Mt. Pirongia',
  },
]



// WEBPACK FOOTER //
// /opt/build/repo/src/data/slideshow.js